import { Tooltip } from '@material-ui/core';
import React from 'react';

export const StyledTooltip = ({
  children,
  title,
  tooltipProps,
}: {
  children: React.ReactElement;
  title: React.ReactElement | string | number;
  tooltipProps?: Omit<React.ComponentProps<typeof Tooltip>, 'children' | 'title'>;
}) => {
  const ENTER_TOOLTIP_DELAY = 750;
  return (
    <Tooltip
      title={title}
      placement={'bottom'}
      enterDelay={ENTER_TOOLTIP_DELAY}
      enterNextDelay={ENTER_TOOLTIP_DELAY}
      TransitionProps={{ timeout: { appear: 250, enter: 250, exit: 0 } }}
      {...tooltipProps}
    >
      {children}
    </Tooltip>
  );
};
